import { up } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import {
  ContactLabel,
  ContactLabelText,
  StyledStageIcon,
} from 'src/components/domain/contacts/contact-label';
import {
  ContactStageIcon,
  type ContactStageIconProps,
} from 'src/components/domain/contacts/contact-stage-icon';
import { Icon } from 'src/components/general/icon';

export const baseListContainerStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px 20px 0;
  align-items: flex-start;
  align-self: stretch;
`;

export const baseListItemStyles = css`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.porcelain};
  &:last-child {
    border-bottom: none;
  }
`;

export const baseListTitleStyles = css`
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.medium};
  font-size: 13px;
  line-height: 15px;
`;

export const baseListTitleRegularStyles = css`
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;

export const baseListMetaStyles = css`
  color: ${({ theme }) => theme.colors.flint};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
`;

export const baseListStormStyles = css`
  color: ${({ theme }) => theme.colors.storm};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
`;

export const baseEllipsisStyles = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const DashboardAssigneeIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.flint};
  height: 14px;
  width: 14px;
  svg {
    height: 14px;
    width: 14px;
  }
`;

export interface DashboardContactStageIconProps extends ContactStageIconProps {
  variant?: 'small' | 'large';
}

export const DashboardContactStageIcon = styled(
  ({ variant = 'small', ...props }: DashboardContactStageIconProps) => (
    <ContactStageIcon {...props} />
  ),
)<DashboardContactStageIconProps>`
  margin-right: 0;

  ${({ variant = 'small' }) => {
    if (variant === 'large') {
      return css`
        height: 30px;
        width: 30px;
        svg {
          padding: 8px;
          height: 30px;
          width: 30px;
        }
      `;
    }

    return css`
      height: 18px;
      width: 18px;
      svg {
        padding: 3.75px;
        height: 18px;
        width: 18px;
      }
    `;
  }}
`;

export const StyledContactLabel = styled(ContactLabel)<{ variant?: 'small' | 'large' }>`
  && ${StyledStageIcon} {
    ${({ variant = 'small' }) => {
      if (variant === 'large') {
        return css`
          height: 30px;
          width: 30px;
          svg {
            padding: 8px;
            height: 30px;
            width: 30px;
          }
        `;
      }

      return css`
        height: 18px;
        width: 18px;
        svg {
          padding: 3.75px;
          height: 18px;
          width: 18px;
        }
      `;
    }}
  }

  ${ContactLabelText} {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;

    ${up('md')} {
      color: ${({ theme }) => theme.colors.flint};
      font-family: ${({ theme }) => theme.font.regular};
      font-size: 12px;
      font-weight: 400;
    }
  }
`;
